import { __assign, __rest } from "tslib";
import React from "react";
import classNames from "classnames";
import { Button as TaroButton, View } from "../_core/components";
import { Loading } from "../loading";
import { Icon } from "../icon";
import { useConfig } from "../_util/use-config";
export function Button(_a) {
    var _b;
    var _c = _a.type, type = _c === void 0 ? "default" : _c, _d = _a.fixed, fixed = _d === void 0 ? false : _d, _e = _a.size, size = _e === void 0 ? "lg" : _e, className = _a.className, children = _a.children, danger = _a.danger, text = _a.text, disabled = _a.disabled, loading = _a.loading, loadingText = _a.loadingText, icon = _a.icon, props = __rest(_a, ["type", "fixed", "size", "className", "children", "danger", "text", "disabled", "loading", "loadingText", "icon"]);
    var classPrefix = useConfig().classPrefix;
    var iconProps = typeof icon === "string" ? { name: icon } : icon;
    return (React.createElement(TaroButton, __assign({ disabled: disabled, className: classNames(classPrefix + "-button", classPrefix + "-button--" + type, "size-" + size, className, (_b = {},
            _b[classPrefix + "-button--fixed"] = fixed,
            _b[classPrefix + "-button--danger"] = danger,
            _b[classPrefix + "-button--solid"] = !text,
            _b[classPrefix + "-button--text"] = text,
            // [`${classPrefix}-button--outline`]: ghost,
            _b["is-disabled"] = disabled,
            _b["is-loading"] = loading,
            _b)) }, props), loading ? (React.createElement(React.Fragment, null,
        React.createElement(Loading, { className: classPrefix + "-button__icon" }),
        loadingText && (React.createElement(View, { className: classPrefix + "-button__icon-text" }, loadingText)))) : (React.createElement(React.Fragment, null, iconProps ? (React.createElement(React.Fragment, null,
        React.createElement(Icon, __assign({}, iconProps, { className: classNames(classPrefix + "-button__icon", iconProps.className) })),
        children && (React.createElement(View, { className: classPrefix + "-button__icon-text" }, children)))) : (children)))));
}
Button.Group = function ButtonGroup(_a) {
    var className = _a.className, _b = _a.type, type = _b === void 0 ? "vertical" : _b, content = _a.content, children = _a.children, props = __rest(_a, ["className", "type", "content", "children"]);
    var classPrefix = useConfig().classPrefix;
    return (React.createElement(View, __assign({ className: classNames(classPrefix + "-button-group", classPrefix + "-button-group--" + type, className, {
            "with-content": content,
        }) }, props),
        content && (React.createElement(View, { className: classPrefix + "-button-group__content" }, content)),
        children));
};
//# sourceMappingURL=Button.js.map